import apiClient from '../lib/axios';

export interface AuditLog {
  id: string;
  userId: string | null; // null for automated (system) actions
  action: string;
  entityType?: string;
  entityId?: string;
  details?: any;
  ipAddress?: string;
  userAgent?: string;
  createdAt: string;
  user?: {
    firstName: string;
    lastName: string;
    email: string;
  };
}

class AuditService {
  /**
   * Get audit logs with optional filters
   */
  async getAuditLogs(params?: {
    userId?: string;
    action?: string;
    entityType?: string;
    entityId?: string;
    startDate?: string;
    endDate?: string;
    page?: number;
    limit?: number;
  }) {
    const response = await apiClient.get('/audit-logs', { params });
    return response.data;
  }

  /**
   * Get a single audit log by ID
   */
  async getAuditLog(id: string): Promise<AuditLog> {
    const response = await apiClient.get(`/audit-logs/${id}`);
    return response.data.data;
  }

  /**
   * Get audit history for a specific entity
   */
  async getEntityHistory(
    entityType: string,
    entityId: string,
    params?: { page?: number; limit?: number }
  ) {
    const response = await apiClient.get(`/audit-logs/entity/${entityType}/${entityId}`, {
      params,
    });
    return response.data;
  }

  /**
   * Get audit history for a specific user
   */
  async getUserActivity(userId: string, params?: { page?: number; limit?: number }) {
    const response = await apiClient.get(`/audit-logs/user/${userId}`, { params });
    return response.data;
  }
}

export const auditService = new AuditService();
